export default {
  approved: { text: 'Approved', color: 'green lighten-4' },
  pending: { text: 'Pending', color: 'orange lighten-1' },
  rejected: { text: 'Denied', color: 'red lighten-1' },
  missing: { text: 'Missing', color: 'yellow lighten-4' },
  not_applicable: { text: 'Not Applicable', color: 'blue lighten-4' },
  waived: { text: 'Waived', color: 'pink lighten-4' },
};
